// Anglar
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Layout Directives
// Services
import {
	ContentAnimateDirective,
	FirstLetterPipe,
	GetObjectPipe,
	HeaderDirective,
	JoinPipe,
	MenuDirective,
	OffcanvasDirective,
	SafePipe,
	ScrollTopDirective,
	SparklineChartDirective,
	StickyDirective,
	TabClickEventDirective,
	TimeElapsedPipe,
	ToggleDirective,
	FileSizePipe,
	IdrCurrencyPipe,
	SmartCurrencyTextPipe
} from './_base/layout';

@NgModule({
	imports: [CommonModule],
	declarations: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		SparklineChartDirective,
		ContentAnimateDirective,
		StickyDirective,
		// pipes
		IdrCurrencyPipe,
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		FileSizePipe,
		FirstLetterPipe,
		SmartCurrencyTextPipe,
	],
	exports: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		SparklineChartDirective,
		ContentAnimateDirective,
		StickyDirective,
		// pipes
		IdrCurrencyPipe,
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		FileSizePipe,
		FirstLetterPipe,
		SmartCurrencyTextPipe,
	],
	providers: []
})
export class CoreModule {
}
